import { render, staticRenderFns } from "./FAQBoardList.vue?vue&type=template&id=76605540&scoped=true"
import script from "./FAQBoardList.vue?vue&type=script&lang=js"
export * from "./FAQBoardList.vue?vue&type=script&lang=js"
import style0 from "./FAQBoardList.vue?vue&type=style&index=0&id=76605540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76605540",
  null
  
)

export default component.exports